import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {Router} from "@/rawdogjs/src/router";
import {LoadingView} from "./loadingView";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class LoadingPresenter implements IPresenter {
    
    private _router: Router;
    
    public _view: LoadingView;
    private _dependencyContainer: ParcelDependencyContainer;

    constructor(loadingView: LoadingView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = loadingView;
        this._router = router;
        this._dependencyContainer = dependencyContainer;
    }

    initialize() {
    }

    inject() {
    }
    
    public show(show:boolean){
        this._view.show(show);
    }

    public setTitle(title:string) {
        this._view.title = title;
    }

    public setBody(body:string) {
        this._view.body  = body;
    }

}